import React from 'react'
import { useMediaQuery } from '../../../hooks/useMediaQuery'
import { ReactComponent as DownloadApple } from './assets/download_apple.svg'
import { ReactComponent as DownloadGoogle } from './assets/download_google.svg'
import clsx from 'clsx'
import style from './style.module.scss'

export const PromoteApp: React.FC<{ apple: string; google: string }> = ({ apple, google }) => {
    const isMobile = useMediaQuery('(max-width: ' + style.mobileBreakpoint + ')')

    return (
        <div className={clsx(style.appContainer, isMobile && style.mobile)}>
            <div className={style.titleContainer}>
                <span className={style.title}>Téléchargez l'application officielle</span>
                <span className={style.subtitle}>de la fédération française de handball</span>
            </div>
            <div className={style.download}>
                <a href={apple ?? '#'} target="_blank" rel="noreferrer">
                    <DownloadApple className={style.apple} />
                </a>
                <a href={google ?? '#'} target="_blank" rel="noreferrer">
                    <DownloadGoogle className={style.google} />
                </a>
            </div>
        </div>
    )
}
